import React from 'react';
import Orders from './Orders';

function OrdersReturned() {
  return <Orders status="returned" />;
}

export default OrdersReturned;
